module.exports = __webpack_public_path__ + "static/FormulaWheelElectronics-5f26b087c951c73eb626a2d0219bfddb.png";